import { useEffect, useState } from 'react';

/**
 * useDetectOTBanner
 *
 * @returns boolean
 */
export const useDetectOTBanner = () => {
    const [isOTBannerVisible, setIsOTBannerVisible] = useState(false);

    useEffect(() => {
        // Check if the browser API is available
        if (typeof window === 'undefined') {
            return;
        }

        // interval to obtain the Onetrust object
        const OTInterval = setInterval(() => {
            // Check if OneTrust is available
            const onetrust = window?.OneTrust;
            const isOneTrustActive = !!onetrust;

            if (isOneTrustActive) {
                setIsOTBannerVisible(!onetrust?.IsAlertBoxClosed());
                // clear interval if OneTrust object is found
                clearInterval(OTInterval);

                window.addEventListener('consent.onetrust', () => {
                    setIsOTBannerVisible(!onetrust?.IsAlertBoxClosed());
                });
            }
        }, 1000);

        setTimeout(() => {
            // clear interval if OT is not active after 5 seconds
            clearInterval(OTInterval);
        }, 10000);
    }, []);

    return isOTBannerVisible;
};
